export default __webpack_public_path__ + "static/pg-22845621062305f052ca675a29d5e2e1.svg";